import { builder as defaultBuilder } from '@ogury/unmarshaller';

/**
 * Helper for builder an unmarshaller object
 *
 * @returns {Object}
 */
export const builder: any = {
  ...defaultBuilder,

  exists: (name: string, options?: any) => ({
    name,
    type: 'exists',
    parser: (x: any) => Boolean(x),
    ...options
  }),
  icon: (name: string, options?: any) => ({
    name,
    type: 'icon',
    parser: (x: any) => String(x),
    ...options
  }),
  color: (name: string, options?: any) => ({
    name,
    type: 'color',
    parser: (x: any) => String(x),
    ...options
  }),
  csv: (
    name: string,
    options: { delimiter?: string } = { delimiter: ' ' }
  ) => ({
    name,
    type: 'csv',
    parser: (x: string) => x.split(options.delimiter || ' ').map(x => x.trim()),
    ...options
  }),
  arrayString: (name: string, options?: any) => ({
    name,
    type: 'arrayString',
    parser: (value: any) => value || [],
    ...options
  })
};
